/**
 * Admin Global Access Grant hooks
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchGlobalAccessGrant,
  upsertGlobalAccessGrant,
  applyGlobalAccessGrantBatch,
  revokeGlobalAccessGrantBatch,
} from "../utils/adminApi";

export const GLOBAL_ACCESS_GRANT_QUERY_KEY_PREFIX = ["admin", "global-access-grant"];

export const useGlobalAccessGrant = () =>
  useQuery({
    queryKey: [...GLOBAL_ACCESS_GRANT_QUERY_KEY_PREFIX, "current"],
    queryFn: () => fetchGlobalAccessGrant(),
    refetchOnWindowFocus: false,
  });

export const useUpsertGlobalAccessGrant = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => upsertGlobalAccessGrant(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: GLOBAL_ACCESS_GRANT_QUERY_KEY_PREFIX });
    },
  });
};

export const useApplyGlobalAccessGrantBatch = () =>
  useMutation({
    mutationFn: ({ cursor = null, limit = 200 } = {}) => applyGlobalAccessGrantBatch({ cursor, limit }),
  });

export const useRevokeGlobalAccessGrantBatch = () =>
  useMutation({
    mutationFn: ({ cursor = null, limit = 200 } = {}) => revokeGlobalAccessGrantBatch({ cursor, limit }),
  });

